// Utilidades compartidas para el filtro de RUTs que permite pegar una lista de
// RUTs de una sola vez y validarlos en el acto. Originalmente vivían en
// `components/pages/Postulaciones/postulacionesUtils.ts`; se extrajeron acá para
// que cualquier tabla con filtro de RUT pueda reutilizar la misma lógica de
// parseo y validación sin depender de la carpeta de una página puntual.

export interface IRutCandidate {
  raw: string;
  formatted: string;
  isValidFormat: boolean;
  isValid: boolean;
  error?: string;
}

const calculateRutVerifier = (body: string): string => {
  let sum = 0;
  let multiplier = 2;

  for (let index = body.length - 1; index >= 0; index -= 1) {
    sum += Number(body[index]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const remainder = 11 - (sum % 11);
  if (remainder === 11) return "0";
  if (remainder === 10) return "K";
  return String(remainder);
};

export const parseRutCandidate = (raw: string): IRutCandidate => {
  const normalized = raw.trim().toUpperCase().replace(/[.\s]/g, "");
  const compact = normalized.replace(/-/g, "");

  if (!/^\d{7,8}[0-9K]$/.test(compact)) {
    return {
      raw,
      formatted: normalized,
      isValidFormat: false,
      isValid: false,
      error: "No se pudo reconocer el formato del RUT.",
    };
  }

  const body = compact.slice(0, -1);
  const verifier = compact.slice(-1);
  const formatted = `${body}-${verifier}`;
  const isValid = calculateRutVerifier(body) === verifier;

  return {
    raw,
    formatted,
    isValidFormat: true,
    isValid,
    error: isValid ? undefined : "El dígito verificador no corresponde al RUT.",
  };
};

export const parseRutList = (value: string): IRutCandidate[] => {
  return value
    .split(/[\r\n,;]+/)
    .map((entry) => entry.trim())
    .filter(Boolean)
    .map(parseRutCandidate);
};
